/**
 * Created by lizheng on 2018/6/23.
 */
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}


//设备检测  是移动端返回true；PC端返回false
function detect() {
  if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  ){
    return false;
  }
  return true;
}

export const device = detect()

export function pushChildren(parent, children){
  children.map((child) => {
    parent.map((parent) => {
      if(!parent.children) {
        parent.children = [];
      }
      if(child.productTypeId === parent.id){
        parent.children.push(child)
      }
    })
  })
}

export function productCombine(data = []){
  const norm = {};
  data.map(item => {
    if(item.spec1){
      if(!norm.spec1){
        norm.spec1 = []
      }
      norm.spec1.push({spec:item.spec1,productId:item.id,stock:item.stock})
    }
    if(item.spec2){
      if(!norm.spec2){
        norm.spec2 = []
      }
      norm.spec2.push({spec:item.spec2,productId:item.goodId,stock:item.stock})
    }
  })
  return norm;
}

export function getCookie(c_name)
{
  let c_start,c_end
  if (document.cookie.length>0)
  {
    c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1)
    {
      c_start=c_start + c_name.length+1
      c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
    }
  }
  return ""
}


// WEBPACK FOOTER //
// ./src/utils/storage.js